import type ReportStruct from 'modules/reports/lib/ReportStruct'

interface LayoutConfiguration {
  i: string
  static: boolean
  w: number
  h: number
  minW: number
  minH: number
  x: number
  y: number
}
interface Layouts {
  lg: LayoutConfiguration[]
  md: LayoutConfiguration[]
  sm: LayoutConfiguration[]
  xs: LayoutConfiguration[]
  xxs: LayoutConfiguration[]
}

export const DASHBOARD_COLS = 4

export const generateLayout = (items: ReportStruct[]): Layouts => {
  const itemsWithMins = items.map((item, index) => {
    return {
      i: item.templateSlug,
      static: true,
      // To visualize templates properly, default vertical and horizontal size is 2
      w: 2,
      h: 2,
      minW: 2,
      minH: 2,
      // There are two elements per row, so we need the remainder of dividing per 2. Giving
      // that the width is 2, we also multiply the value by 2 (0, 2, 0, 2, 0, 2...)
      x: (index % 2) * 2,
      // There are two elements per row, so we get the floor of dividing the index by 2. Giving
      // that the height is 2, we also multiply the value by 2 (0, 0, 2, 2, 4, 4...)
      y: Math.floor(index / 2) * 2,
    }
  })

  return {
    lg: itemsWithMins,
    md: itemsWithMins,
    sm: itemsWithMins,
    xs: itemsWithMins,
    xxs: itemsWithMins,
  }
}
